import { render, staticRenderFns } from "./Subsribers.vue?vue&type=template&id=536dc639"
import script from "./Subsribers.vue?vue&type=script&lang=js"
export * from "./Subsribers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports